import { Button } from '$components'
import { useCreateSizeCategoryForm } from './index'

export function CreateSizeCategoryFormControls() {
  const { onCancel, isLoading } = useCreateSizeCategoryForm()

  return (
    <div className="flex gap-stack-roomy mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Button
        isLoading={isLoading}
        type="submit"
        size="lg"
      >
        Create Size
      </Button>
    </div>
  )
}
